module.exports = __webpack_public_path__ + "static/media/default-post.33f2c941.jpg";